import type { ReactNode } from 'react'
import { Stack, Typography } from '@mui/material'
import { useAlertBanner } from '@src/contexts/alert-banner-context'
import type { GlobalBreadcrumbsProps } from './GlobalBreadcrumbs'
import GlobalBreadcrumbs from './GlobalBreadcrumbs'
import PageContainer from './PageContainer'

interface Props {
  title: ReactNode
  breadcrumbs: GlobalBreadcrumbsProps
  actions?: ReactNode
}

// Recommended MUI Layouting from Toolpad interface style: https://mui.com/toolpad/core/react-page-container/
const PageHeader = ({ breadcrumbs, title, actions }: Props) => {
  const { banner } = useAlertBanner()
  const hasAlertBanner = banner.message !== null

  return (
    <PageContainer disableBottomGutter sx={{ mb: 1, mt: hasAlertBanner ? 6 : 0 }}>
      <GlobalBreadcrumbs path={breadcrumbs.path} current={breadcrumbs.current} />
      <Stack direction="row" gap={1}>
        <Typography variant="h4" sx={{ flexGrow: 1 }}>
          {title}
        </Typography>
        {actions}
      </Stack>
    </PageContainer>
  )
}

export default PageHeader
